export default class UpdateInspectionAreaModel {
    assetId = null;
    scanId = null;
    id = null;
    transform = null;
    markerIds = [];
    hotSpotIds = [];
    name = null;
    eTag = null;

    constructor(id, assetId, transform = null, markerIds = [], hotSpotIds = [], name = null, eTag, scanId = null){
        this.id = id;
        this.assetId = assetId;
        this.scanId = scanId;
        this.transform = transform;
        this.markerIds = markerIds;
        this.hotSpotIds = hotSpotIds;
        this.name = name;
        this.eTag = eTag;
    }
}